var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {}, _obj[_vm.$style.debug] = _vm.debug, _obj ),attrs:{"data-mf-replace":_vm.placeholder}},[(_vm.debug)?_c('span',{class:_vm.$style.placeholder},[_vm._v(_vm._s(_vm.placeholder))]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }